<template>
    <div class="mp-media-activity">
        <el-row class="section" v-show="showMpChoose">
            <el-col :span="24">
                <el-collapse accordion v-model="activeName">
                    <el-collapse-item name="1">
                        <template slot="title">
                            <span>请选择公众号：</span>
                        </template>
                        <div class="grid-content bg-purple-dark">
                            <el-row>
                                <el-col :span="12">
                                    <el-select v-model="mpAuthConfigId" placeholder="请选择公众号">
                                        <el-option
                                                v-for="item in mpAuthConfigs"
                                                :key="item.id"
                                                :label="item.nickName"
                                                :value="item.id">
                                        </el-option>
                                    </el-select>
                                </el-col>
                            </el-row>
                        </div>

                    </el-collapse-item>
                </el-collapse>
            </el-col>
        </el-row>


        <el-row class="setting section">
            <el-col :span="24">
                <el-collapse accordion v-model="activeName1">
                    <el-collapse-item name="1">
                        <template slot="title">
                            <div class="title">
                                <div @click.stop>
                                    <span>是否开启：</span>
                                    <el-switch v-model="item.open"></el-switch>
                                </div>
                                <span v-if="item.triggerType"
                                      class="trigger">触发方式：<strong>{{ item.triggerTypeText }}</strong></span>
                                <span v-if="item.triggerType=='keyword'"
                                      class="trigger">关键词：<strong>{{ item.keyword }}</strong></span>
                                <a class="head-tip" href="https://www.yuque.com/yifakeji/irpssl/yz0osv"
                                   target="_blank">不会设置?点击看活码设置教程</a>
                            </div>
                        </template>
                        <el-alert
                                title="温馨提示"
                                type="success"
                                close-text="知道了"
                                show-icon>
                            <p>关键词触发：触发关键词的时候触发</p>
                            <p>关注触发：关注公众号触发</p>
                            <p>关键词、关注都触发：关注公众号和关键词都触发</p>
                            <p>请先保存，保存以后，才可以设置下面的文案和活码</p>
                            <p style="color: #ff0036">开启屏蔽其它选项以后，则公众号回复任何关键词都只是发送活码</p>
                        </el-alert>
                        <div class="grid-content bg-purple-dark">
                            <el-form ref="form" :model="item" label-width="80px" label-position="left">
                                <el-form-item label="触发类型:">
                                    <el-radio-group v-model="item.triggerType">
                                        <el-radio label="keyword">关键词触发</el-radio>
                                        <el-radio label="subscribe">关注触发</el-radio>
                                        <el-radio label="all">关键词、关注都触发</el-radio>
                                    </el-radio-group>
                                </el-form-item>
                                <el-form-item label="关键词:"
                                              v-if="item.triggerType == 'keyword' || item.triggerType == 'all'">
                                    <el-col :span="12">
                                        <el-input v-model="item.keyword" placeholder="关键词用|隔开"></el-input>
                                    </el-col>
                                </el-form-item>
                                <el-form-item label="屏蔽其它:">
                                    <el-switch v-model="item.ignoreOther"></el-switch>
                                </el-form-item>
                                <el-form-item>
                                    <el-button type="primary" size="medium" @click="onSubmit">保存</el-button>
                                    <el-button size="medium">取消</el-button>
                                </el-form-item>
                            </el-form>
                        </div>
                    </el-collapse-item>
                </el-collapse>
            </el-col>
        </el-row>
        <el-row class="section">
            <el-col :span="24">
                <el-tabs type="border-card" v-model="currentTab">
                    <el-tab-pane label="第一段文案" name="first">
                        <text_list :sort=1 :mediaActivityId="item.id" :mpAuthConfigId="mpAuthConfigId"
                                   v-if="currentTab=='first'&&item.id"></text_list>
                    </el-tab-pane>
                    <el-tab-pane label="活码图片" name="second">
                        <image_list :mediaActivityId="item.id" :mpAuthConfigId="mpAuthConfigId"
                                    v-if="currentTab=='second'"></image_list>
                    </el-tab-pane>
                    <el-tab-pane label="第三段文案" name="third">
                        <text_list :sort=3 :mediaActivityId="item.id" :mpAuthConfigId="mpAuthConfigId"
                                   v-if="currentTab=='third'&&item.id"></text_list>
                    </el-tab-pane>
                </el-tabs>
            </el-col>
        </el-row>
    </div>

</template>
<script>
import {mediaActivityApi} from "../../common/mediaActivityApi"
import {mpAuthConfigApi} from "../../common/mpAuthConfigApi";

export default {
    name: "index",
    components: {
        text_list: require('./text_list').default,
        image_list: require('./image_list').default,
    },
    watch: {
        'item.triggerType': {
            handler: function () {
                if (this.item.triggerType == 'keyword') {
                    this.item.triggerTypeText = "关键词触发"
                } else if (this.item.triggerType == 'subscribe') {
                    this.item.triggerTypeText = "关注触发"
                } else {
                    this.item.triggerTypeText = "关键词、关注都触发"
                }
            }
        },
        mpAuthConfigId(newValue, oldValue) {
            this.refresh = false;
            this.onload();
            this.refresh = true;

        }

    },
    created() {

    },
    mounted() {
        var that = this
        mpAuthConfigApi.getMpAuthConfigs.call(that, {}, function (res) {
            var pastMpConfigs = []
            if (res.result.mpConfigs && res.result.mpConfigs.length > 0) {
                for (var i = 0; i < res.result.mpConfigs.length; i++) {
                    if (res.result.mpConfigs[i].mpAuthConfigStatus == 'HAS_PAST') {
                        pastMpConfigs.push(res.result.mpConfigs[i])
                    }
                }

            }
            if (pastMpConfigs.length > 1) {
                that.showMpChoose = true
            }
            that.mpAuthConfigs = pastMpConfigs;
            that.mpAuthConfigId = pastMpConfigs[0].id
            that.onload();
        })

    },
    data() {
        return {
            open: false,
            showMpChoose: false,
            currentTab: 'first',
            activeName: "1",
            activeName1: "1",
            mpAuthConfigId: null,
            mpAuthConfigs: [],
            item: {
                open: false,
                triggerType: 'keyword',
                triggerTypeText: "关键词触发",
                id: null,
            },
            tabs: [],
            texts: [],
            refresh: false
        }
    },
    methods: {
        onload() {
            var that = this;
            mediaActivityApi.getMediaActivity.call(that, {mpAuthConfigId: that.mpAuthConfigId}, function (res) {
                    if (res.result.data && res.result.data.length > 0) {
                        that.item = null;
                        that.item = res.result.data[0];
                        that.$forceUpdate();

                    } else {
                        that.item = {};
                    }
                },
                function (data) {

                }
            )
        },
        newText() {
            this.texts.push({"text": ""})
        },
        deleteText(index) {
            this.texts.splice(index, 1)
        },
        onSubmit() {
            var that = this;
            if ((that.item.triggerType == 'keyword' || that.item.triggerType == 'all') && this.isEmpty(this.item.keyword)) {
                that.errorMsg('关键词不能为空')
                return;
            }
            that.item.mpAuthConfigId = that.mpAuthConfigId
            that.item.mediaActivityType = 'ggh'
            mediaActivityApi.createMediaActivity.call(that, that.item, function (res) {
                if (res.result.item) {
                    that.item = res.result.item;
                }
            })
        }
    }
}

</script>
<style lang="scss">

.mp-media-activity {
  text-align: left;

  .head-tip {
    margin-left: 10px;
    color: #ff0036;
  }

  .title {
    margin-left: 10px;
    display: flex;
    align-items: center;

    .trigger {
      margin-left: 20px;
    }

    strong {
      color: $hover-color;
    }

  }

  .el-collapse {
    border: none;
  }

  .el-collapse-item__wrap {
    border: none;
  }


  .el-collapse-item__content {
    padding-bottom: 0px;
  }
}

</style>